<template>
  <div class="not-found-container">
    <div class="details-container">
      <h1>404 - Page Not Found</h1>
      <p>
        We're sorry, but the page you're looking for doesn't exist or has been moved.
        Please check the URL and try again.
      </p>
      <p>
        If you believe this is an error or need further assistance,
        please contact us at: <a href="mailto:info@lelandlittle.com">info@lelandlittle.com</a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
    name: 'PageNotFoundComponent',
    mixins: [],
    mounted() { },
    methods: {},
}
</script>

<style scoped>
.not-found-container {
    display: flex;
    height: 70vh;
    width: 100%;
}

.details-container {
    text-align: center;
    margin-left: auto;
    margin-right: auto;
}

h1 {
    font-size: 2rem;
    color: #333;
    margin-bottom: 1rem;
}

p {
    font-size: 1em;
    color: #666;
    margin-bottom: 1em;
}

a {
    color: #007AFF;
    text-decoration: none;
}

a:hover {
    text-decoration: underline;
}
</style>